export default __webpack_public_path__ + "static/B02-cb2b960c3d8b22b47e369c1f241481e3.png";